import { render, staticRenderFns } from "./SushiItem.vue?vue&type=template&id=9f5b58e4&scoped=true&"
import script from "./SushiItem.vue?vue&type=script&lang=js&"
export * from "./SushiItem.vue?vue&type=script&lang=js&"
import style0 from "./SushiItem.vue?vue&type=style&index=0&id=9f5b58e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5b58e4",
  null
  
)

export default component.exports